module.exports = __webpack_public_path__ + "img/red-winged-blackbird.56a64eb0.jpg";